import React, { useEffect, useState } from "react";
import $, { data } from "jquery";
import ShadowLayer from "../assets/solidbackgroundimg.png";
import CustomButton from "./CustomButton";
import MarkupGrid from "./MarkupGrid";
import RowList from "./RowList";
import ThumbnailnoImage from "../assets/thumbnailNoImage.png";
import { fetchContent } from "../services/api";
import favouriteIcon from "../assets/Added.png";
import addtofavouriteIcon from "../assets/addtofavorite.png";
import selectedlikeIcon from "../assets/selectedLike.png";
import selectedDislikeIcon from "../assets/selectedDislike.png";
import likeIcon from "../assets/like.png";
import dislikeIcon from "../assets/dislike.png";
import idmdimg from "../assets/idmdimg.png";
import { Translate } from "./LanguageChanger";
import AnimatedGrid from "./AnimatedGrid";
import AppInAppListData from "./AppInAppListData";

let addKeyListener;
let focusedIndx = 1;
let resolution = window.RESOLUTION;
let setDefaultFocus;
let interval;
let ReseTfocus1;
let isKeyListenerAdded = false; // Flag to track if the event listener is added
var currentScreen;
let SetFocusTodefault;
var seasonTab = [];
var artist = [];
var similar = [];
var Episodes = [];
var flg = false;
let isDeleted;
let Dislike;
let like;


const AppInApp = ({
  banneritems,
  callBack,
  animation,
  navigate,
  isDetails,
  FocusHandler,
  shouldFocusToScreenBG,
  isLogedIn,
  handleBackButton,
  itemDetails,
  appinappData,
  isSeriess = false,
  handleErr,
  onSelect,
  isChild,
  navigateScreen,
}) => {
  const [rerender, setrerenderState] = useState({ rerender: false });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [imgSrc, setImgSrc] = useState(addtofavouriteIcon);
  const [isNavigating, setIsNavigating] = useState(false);
  const [state, setState] = useState({
    isWatchNowSelected: shouldFocusToScreenBG ? true : false,
    isMoreInfoSelected: false,
    isAddFavoriteSelected: false,
    isLikeSelected: false,
    isDislikeSelected: false,
    isSeries: isSeriess,
    isEpisodeSelected: false,
    isCastCreSelected: false,
    isSimilarSelected: false,
    TabContent: [],
    watchlistItems: [],
    likeDislikeItems: [],
    shouldFocusGrid: false,
    shouldFocusToRowList: true,
    shouldFocusToSeasonRowList: false,
    shouldFocusToEpisodeGrid: false,
    shouldFocusToGrid: true,
    shoulddetailsOpen: flg,
    shouldshowSeasonRowlist: false,
    itemComponentName: "EpisodesWidget",
    episodeMarginTop: "265px",
  });
  const {
    isWatchNowSelected,
    isMoreInfoSelected,
    isAddFavoriteSelected,
    isLikeSelected,
    isDislikeSelected,
    isSeries,
    isEpisodeSelected,
    isCastCreSelected,
    isSimilarSelected,
    TabContent,
    shouldFocusGrid,
    shouldFocusToRowList,
    shouldFocusToSeasonRowList,
    shouldFocusToEpisodeGrid,
    shoulddetailsOpen,
    shouldshowSeasonRowlist,
    itemComponentName,
    episodeMarginTop,
    watchlistItems,
    shouldFocusToGrid,
    likeDislikeItems,
  } = state;

  addKeyListener = () => {
    if (!isKeyListenerAdded) {
      window.addEventListener("keydown", AppInAppKeyHandler);
      isKeyListenerAdded = true; // Set the flag to true
      setState((prevState) => ({
        ...prevState,
        isWatchNowSelected: true,
        isMoreInfoSelected: false,
      }));
    }
  };

  ReseTfocus1 = () => {
    focusedIndx = 1;
  }

  SetFocusTodefault = (focusedIndx) => {
    if (focusedIndx >= 0) {
      currentScreen = "DetailScreen";
      prevIndex = focusedIndx;
      setCurrentIndex = focusedIndx;
      setrerenderState({ rerender: !rerender });
    } else {
      currentIndex = prevIndex;
      setrerenderState({ rerender: !rerender });
    }
  };

  // useEffect(() => {
  //   // if (isWatchNowSelected === false && isMoreInfoSelected === false) return;
  //   if (shouldFocusToScreenBG) {
  //     console.log("111111111111111............");
  //     setTimeout(function () {
  //       addKeyListener();
  //       if (!isNavigating) { // Check if navigation is active
  //       }
  //     }, 300);
  //   } else {
  //     console.log("22222222222222222222............");
  //     window.removeEventListener("keydown", AppInAppKeyHandler);
  //     isKeyListenerAdded = false; // Reset the flag
  //   }
  //   // if (animation) {
  //   //   interval = setInterval(() => {
  //   //     setPrevIndex(currentIndex);
  //   //     setCurrentIndex((prevIndex) => (prevIndex + 1) % banneritems.length);
  //   //   }, 15000); // Change every 15 seconds
  //   // }

  //   // return () => {
  //   //   if (interval) clearInterval(interval); // Cleanup interval on component unmount
  //   //   window.removeEventListener("keydown", BGScreenKeyHandler);
  //   //   isKeyListenerAdded = false; // Reset the flag
  //   // };
  // },[itemDetails]); 
  // useEffect(() => {
  //   if (isWatchNowSelected === false && isMoreInfoSelected === false) return;
  //   if (shouldFocusToScreenBG) {
  //     setTimeout(function () {
  //       addKeyListener();
  //       if (!isNavigating) { // Check if navigation is active
         
  //       }
  //     }, 500);
  //   } else {
  //     window.removeEventListener("keydown", AppInAppKeyHandler);
  //     isKeyListenerAdded = false; // Reset the flag
  //   }
  //   if (animation) {
  //     interval = setInterval(() => {
  //       setPrevIndex(currentIndex);
  //       setCurrentIndex((prevIndex) => (prevIndex + 1) % banneritems.length);
  //     }, 15000); // Change every 15 seconds
  //   }

  //   return () => {
  //     if (interval) clearInterval(interval); // Cleanup interval on component unmount
  //     window.removeEventListener("keydown", AppInAppKeyHandler);
  //     isKeyListenerAdded = false; // Reset the flag
  //   };
  // }, [banneritems, currentIndex, animation, shouldFocusToScreenBG]);

  useEffect(() => {
    if (itemDetails && itemDetails.length > 0) {
      const seriesInfo = itemDetails[0].season;
      if (seriesInfo && seriesInfo.length > 0) {
        var isEpsode = false;
        seasonTab = [];
        artist = [];
        similar = [];
        Episodes = [];
        for (var i = 0; i < itemDetails[0].season.length; i++) {
          isEpsode = true;
          assoc = {
            id: itemDetails[0].season[i].id,
            title: itemDetails[0].season[i].title,
          };
          seasonTab.push(assoc);
          if (
            itemDetails[0].season[i].artist !== undefined &&
            itemDetails[0].season[i].artist.length > 0
          ) {
            for (var j = 0; j < itemDetails[0].season[i].artist.length; j++) {
              var assoc = {
                title: itemDetails[0].season[i].artist[j].artists_name,
                thumbnail: itemDetails[0].season[i].artist[j].profile_image,
                artist_type_name:
                  itemDetails[0].season[i].artist[j].artists_type_name,
              };
              artist.push(assoc);
            }
          }
          if (
            itemDetails[0].season[i].videos !== undefined &&
            itemDetails[0].season[i].videos.length > 0
          ) {
            var assoc = {
              seasonTitle: itemDetails[0].season[i].title,
              seasonID: itemDetails[0].season[i].id,
              episodes: itemDetails[0].season[i].videos,
            };
            Episodes.push(assoc);
          }
        }
        let content = [];
        if (isEpsode) {
          content = Episodes.length > 0 ? Episodes[0].episodes : [];
        } else {
          content = artist;
        }

        setState((prevState) => ({
          ...prevState,
          isSeries: true,
          isEpisodeSelected: true,
          isCastCreSelected: false,
          TabContent: content,
          shouldshowSeasonRowlist: true,
        }));
      } else {
        if (
          itemDetails[0].artist !== undefined &&
          itemDetails[0].artist.length > 0
        ) {
          for (var j = 0; j < itemDetails[0].artist.length; j++) {
            var assoc = {
              title: itemDetails[0].artist[j].artists_name,
              thumbnail: itemDetails[0].artist[j].profile_image,
              artist_type_name: itemDetails[0].artist[j].artists_type_name,
            };
            artist.push(assoc);
          }
        }
        let content = [];
        content = artist;
        setState((prevState) => ({
          ...prevState,
          isSeries: false,
          TabContent: content,
          isEpisodeSelected: false,
          isCastCreSelected: true,
        }));
      }
      similar =
        itemDetails[0].related !== undefined ? itemDetails[0].related : [];
    }
    // }   
  }, [itemDetails]);

  const AppInAppKeyHandler = (event) => {
    switch (event.keyCode) {
      case 13:
        break;
      case 38:
        break;
      case 39:
        break;
      case 37:
        break;
      case 40:
        break;
      case 10009:
        break;
      case 8:
        break;
      case 461:
        break;
      default:
        break;
    }
  };

  const styles = {
    ScreenBGItemContainer: {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100vw",
      height: "100vh",
      overflow: "hidden",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: "0",
      left: "0",
    },
    shadowLayer: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      display: "block",
    },
  };

  // const navigateToScreen = (p="",p1={}) =>{
  //   navigate(p,p1)
  // };

  const callback = (event) => { };

  const handleBcak = (action, bol) =>{
    //navigateScreen("HomePage");
    FocusHandler("appinapp");
  }

  const handleRowListDownButton = () => {
  };

  const handleRowListUpButton = () => {
  };

  const handleMarkipGridUpButton = () => {
  };

  const handleItemSelected = (item) => {
  };

  const AppInApp_Navigate = (p) => {
    // console.log("AppInApp_Navigate called ------------ = ",AppInApp_Navigate);
   // navigateScreen(p);
  };

  const navigateToScreen = (p="", p1) =>{
    console.log("navigateToScreen called ------------ = ",p, p1);
    navigate(p, p1)
  };

  return (console.log("App in App Data", itemDetails),
    <div style={styles.ScreenBGItemContainer}>
        {/* <div> */}
         <AppInAppListData
            //   isGridCalled={isGridCalled}
              appinappData={itemDetails}
              isChild={true}
              data={itemDetails}
              columnCount={resolution === "FHD" ? 7 : 7}
              rowHeight={resolution === "FHD" ? 373 : 249}
              rowWidth={"100%"}
              columnWidth={resolution === "FHD" ? 238 : 159}
              columnHeight={resolution === "FHD" ? 300 : 200}
              thumbnailWidth={resolution === "FHD" ? 228 : 142}
              thumbnailHeight={resolution === "FHD" ? 291 : 194}
              gapX={8.5}
              gapY={0}
              selectionColor={"#FF671F"}
              scrollDuration={100}
              defaultRowCount={1}
              horizontalScrollStartIndex={1}
              selectionStyle={"border"} // or 'zoom'
              gridContainerX={resolution === "FHD" ? "118px" : "79px"}
              gridContainerY={"65.5vh"}
              gridContainerWidth={"95vw"}
              gridContainerHeight={"90vh"}
              gridContainerBgColor={"transparent"}
              shouldFocus={shouldFocusToGrid}
              navigate={navigateToScreen}
              FocusHandler={FocusHandler}
              callBack={handleBcak}
              isLogedIn={isLogedIn}
              navigateScreen={AppInApp_Navigate}
            />
        {/* </div> */}
    </div>
  );
};

AppInApp.setFocus = () => {
  addKeyListener();
};

// MenuScreen.SetFocus = (focus) => {
//   addFocus(focus);
// };

// ScreenBGItemScreen.ReseTfocus = (focusedIndx) => {
//   setDefaultFocus();
//   // ScreenBGItemScreen.ReseTfocus(1);
// };

AppInApp.ReseTfocus = (focusedIndx) => {
  ReseTfocus1(1);
  // Setf(focusedIndx);
};

export default AppInApp;
